<qai-results-tab [title]="'results.OBJECTIVES' | transloco" [score]="tabScore" [scoreKind]="tabScoreKind">
  @for (obj of viewObjectives; track obj.title) {
    <qai-section-header
      [subtitle]="obj.title"
      [subtitleIndicator]="obj.scoreIndicator"
      [border]="true"
    />
    <qai-label>{{ obj.feedback }}</qai-label>
    @if (obj.suggestItems.length || obj.whyItems.length) {
      <div class="info-blocks">
        @if (obj.suggestItems.length) {
          <qai-info-block [title]="'results.WHAT_WE_SUGGEST' | transloco" [items]="obj.suggestItems" />
        }
        @if (obj.whyItems.length) {
          <qai-info-block [title]="'results.WHY' | transloco" [items]="obj.whyItems" />
        }
      </div>
    }
  }
</qai-results-tab>
